<template>
  <div class="container">
    <h2>Contact Us</h2>
    <div class="row">
      <div class="col-4 text-right">
        <h4>Send us a message</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-4 text-right my-auto">
        <p class="no-margin-bottom">First Name<span v-if="!firstName" class="required">*</span></p>
      </div>
      <div class="col-4">
        <input v-model="firstName" type="text" class="form-control" v-bind:class="{'is-invalid': firstNameInvalid}">
      </div>
    </div>
    <div class="row">
      <div class="col-4 text-right my-auto">
        <p class="no-margin-bottom">Last Name<span v-if="!lastName" class="required">*</span></p>
      </div>
      <div class="col-4">
        <input v-model="lastName" type="text" class="form-control" v-bind:class="{'is-invalid': lastNameInvalid}">
      </div>
    </div>
    <div class="row">
      <div class="col-4 text-right my-auto">
        <p class="no-margin-bottom">Email<span v-if="!email" class="required">*</span></p>
      </div>
      <div class="col-4">
        <input v-model="email"  type="text" class="form-control" v-bind:class="{'is-invalid': emailInvalid}">
      </div>
    </div>
    <div class="row">
      <div class="col-4 text-right my-auto">
        <p class="no-margin-bottom">Phone</p>
      </div>
      <div class="col-4">
        <input v-model="phone" type="text" class="form-control">
      </div>
    </div>
    <div class="row">
      <div class="col-4 text-right">
        <p class="no-margin-bottom">Interests<span v-if="interests.length === 0" class="required">*</span></p>
      </div>
      <div class="col-4">
        <div class="form-check">
          <input v-model="interests" class="form-check-input" type="checkbox" value="buying" id="defaultCheck1">
          <label class="form-check-label" for="defaultCheck1">
            Buying a Home
          </label>
        </div>
        <div class="form-check">
          <input v-model="interests" class="form-check-input" type="checkbox" value="selling" id="defaultCheck2">
          <label class="form-check-label" for="defaultCheck2">
            Selling a Home
          </label>
        </div>
        <!--<div class="form-check">
          <input v-model="interests" class="form-check-input" type="checkbox" value="concierge" id="defaultCheck3">
          <label class="form-check-label" for="defaultCheck3">
            Concierge Services
          </label>
        </div>-->
      </div>
    </div>
    <div class="row">
      <div class="col-4 text-right">
        <p class="no-margin-bottom">Comments</p>
      </div>
      <div class="col-4">
        <div class="form-group">
          <textarea v-model="comments" class="form-control" id="exampleFormControlTextarea1" rows="3"></textarea>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="offset-2 col-8">
        <b-alert variant="success" dismissible v-model="successAlert">
          Thanks for reaching out! We'll get back to you shortly.
        </b-alert>
      </div>
    </div>
    <div class="row">
      <div class="col-4 offset-4">
        <button v-on:click="contact" class="btn btn-primary">Submit</button>
      </div>
    </div>
    <div class="row">
      <!--<div class="col-md-4 offset-md-2">
        <div class="phone-wrapper">
          <div class="row">
            <div class="col text-center">
              <h3>Concierge Services</h3>
            </div>
          </div>
          <div class="row">
            <div class="col text-center">
              <h3><i class="fas fa-phone fa-rotate-90"></i> (612) 655-2324</h3>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <p class="phone-text text-center">You can also text the word "Concierge" to chat with a business liaison.</p>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <p class="disclaimer">*Carrier data and messaging rates apply</p>
            </div>
          </div>
        </div>
      </div>-->
      <div class="col-md-4 offset-md-4">
        <div class="phone-wrapper">
          <div class="row">
            <div class="col text-center">
              <h3>HomApt Realty</h3>
            </div>
          </div>
          <div class="row">
            <div class="col text-center">
              <h3><i class="fas fa-phone fa-rotate-90"></i> (612) 655-2324</h3>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <p class="phone-text text-center">You can also text the words "Buy" or "Sell" to chat with a realtor.</p>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <p class="disclaimer">*Carrier data and messaging rates apply</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      firstName: null,
      firstNameInvalid: false,
      lastName: null,
      lastNameInvalid: false,
      email: null,
      emailInvalid: false,
      phone: null,
      interests: [],
      interestsInvalid: false,
      comments: null,
      formInvalid: false,
      successAlert: false
    }
  },
  created () {
    if (this.getUserType === 'user') {
      this.firstName = this.getLegalFirstName
      this.lastName = this.getLastName
      this.email = this.getEmail
      this.phone = this.getCellPhone
    }
    if (this.getUserType === 'business') {
      this.firstName = this.getAdminFirstName
      this.lastName = this.getAdminLastName
      this.email = this.getAdminEmail
      this.phone = this.getAdminPhone
    }
  },
  computed: {
    ...mapGetters('user', [
      'getUserType',
      'getLegalFirstName',
      'getLastName',
      'getEmail',
      'getCellPhone'
    ]),
    ...mapGetters('business', [
      'getAdminFirstName',
      'getAdminLastName',
      'getAdminEmail',
      'getAdminPhone'
    ])
  },
  methods: {
    async contact () {
      this.formInvalid = false

      if (!this.firstName) {
        this.firstNameInvalid = true
        this.formInvalid = true
      } else {
        this.firstNameInvalid = false
      }

      if (!this.lastName) {
        this.lastNameInvalid = true
        this.formInvalid = true
      } else {
        this.lastNameInvalid = false
      }

      var emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (!emailRegex.test(this.email)) {
        this.emailInvalid = true
        this.formInvalid = true
      } else {
        this.emailInvalid = false
      }

      if (this.interests.length === 0) {
        this.interestsInvalid = true
        this.formInvalid = true
      } else {
        this.interestsInvalid = false
      }

      if (this.formInvalid) return

      var client = this.$store.getters.getMessageApigClientFactory
      var params = {}
      var pathTemplate = '/contact-us'
      var method = 'POST'
      var additionalParams = {}
      var sellHome = this.interests.includes('selling')
      var buyHome = this.interests.includes('buying')
      var serviceProviders = this.interests.includes('concierge')
      var body = {
        email: this.email,
        first_name: this.firstName,
        last_name: this.lastName,
        sell_home: sellHome,
        buy_home: buyHome,
        service_providers: serviceProviders,
        comments: this.comments,
        phone_number: this.phone
      }
      try {
        await client.invokeApi(params, pathTemplate, method, additionalParams, body)
        this.firstName = null
        this.lastName = null
        this.email = null
        this.phone = null
        this.interests = []
        this.comments = null
        this.successAlert = true
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style scoped>
.btn {
  margin-top: -1rem;
}

.container {
  padding-top: 2rem;
}

.disclaimer {
  font-size: .5rem;
  margin-bottom: 0;
  bottom: .2rem;
  text-align: center;
}

.form-check-label {
  color: #4f4f4f !important;
}

.no-margin-bottom {
  margin-bottom: 0;
}

.phone-text {
  padding-right: 1.5rem;
  padding-left: 1.5rem;
}

.phone-wrapper {
  background-color: #e6e6e6;
  height: 100%;
  border-radius: 20px;
  padding-top: 1rem;
}

.required {
  color: red;
}

.row {
  padding-bottom: 1rem;
}

</style>



// WEBPACK FOOTER //
// src/components/contact/ContactUs.vue